import { fetchDealers } from '@v4/services/api/v3/dealers';

export const dealersHandler = {
    data() {
        return {
            areDealersLoading: false,
            hasError: false,
            dealerList: [],
            hasNoResult: false,
        };
    },
    methods: {
        fetchDealers(zipCode, projectId) {
            if (!projectId) {
                this.areDealersLoading = false;
                return;
            }

            if (this.isError) {
                this.isError = false;
            }

            this.areDealersLoading = true;
            this.dealerList = [];

            return fetchDealers(zipCode, projectId)
                .then(({ data }) => {
                    if (!data) {
                        this.hasNoResult = true;

                        const noResultError = new Error(
                            `Dealer Selection - API - incosistent dealer list data for zip code = ${this.theZipCode}`
                        );
                        this.logSentryError(noResultError);

                        return;
                    }

                    if (data.dealers && Array.isArray(data.dealers) && data.dealers.length > 0) {
                        this.dealerList = data.dealers;
                        this.hasNoResult = false;
                    } else {
                        this.hasNoResult = true;

                        const noResultError = new Error(
                            `Dealer Selection - API - empty dealer list for zip code = ${this.theZipCode}`
                        );
                        this.logSentryError(noResultError, `data: ${JSON.stringify(data)}`);
                    }
                })
                .catch((error) => {
                    this.logSentryError(error, 'Dealer Selection - API - error when fetching dealers');
                })
                .finally(() => {
                    this.areDealersLoading = false;
                });
        },
        logSentryError(error, errorDescription = '') {
            if (window.Sentry) {
                Sentry.captureException(error, {
                    tags: {
                        category: 'dealer-selection',
                        errorDescription,
                    },
                });
            }
        },
    },
};
